var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productHeader"},[_c('h2',{staticClass:"title"},[_vm._v("推荐产品")]),_c('div',{staticClass:"address",on:{"click":_vm.openModal}},[_c('i',{staticClass:"iconfont icon-dingwei-icon iconStyle dingweiColor"}),_c('h2',{staticClass:"addressText"},[_vm._v(_vm._s(_vm.address))])]),_c('div',{attrs:{"id":"iCenter"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }